import * as ambassadorWixRestaurantsV1AvailabilityException from './restaurants-v1-availability-exception-availability-exceptions.http.js';
import * as ambassadorWixRestaurantsV1AvailabilityExceptionTypes from './restaurants-v1-availability-exception-availability-exceptions.types.js';
import * as ambassadorWixRestaurantsV1AvailabilityExceptionUniversalTypes from './restaurants-v1-availability-exception-availability-exceptions.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createAvailabilityException(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsV1AvailabilityExceptionUniversalTypes.CreateAvailabilityExceptionRequest,
  ambassadorWixRestaurantsV1AvailabilityExceptionTypes.CreateAvailabilityExceptionRequest,
  ambassadorWixRestaurantsV1AvailabilityExceptionUniversalTypes.CreateAvailabilityExceptionResponse,
  ambassadorWixRestaurantsV1AvailabilityExceptionTypes.CreateAvailabilityExceptionResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsV1AvailabilityException.createAvailabilityException(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/availability-exceptions',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getAvailabilityException(): __PublicMethodMetaInfo<
  'GET',
  { availabilityExceptionId: string },
  ambassadorWixRestaurantsV1AvailabilityExceptionUniversalTypes.GetAvailabilityExceptionRequest,
  ambassadorWixRestaurantsV1AvailabilityExceptionTypes.GetAvailabilityExceptionRequest,
  ambassadorWixRestaurantsV1AvailabilityExceptionUniversalTypes.GetAvailabilityExceptionResponse,
  ambassadorWixRestaurantsV1AvailabilityExceptionTypes.GetAvailabilityExceptionResponse
> {
  const payload = {
    availabilityExceptionId: ':availabilityExceptionId',
  } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsV1AvailabilityException.getAvailabilityException(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/availability-exceptions/{availabilityExceptionId}',
    pathParams: { availabilityExceptionId: 'availabilityExceptionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateAvailabilityException(): __PublicMethodMetaInfo<
  'PATCH',
  { availabilityExceptionId: string },
  ambassadorWixRestaurantsV1AvailabilityExceptionUniversalTypes.UpdateAvailabilityExceptionRequest,
  ambassadorWixRestaurantsV1AvailabilityExceptionTypes.UpdateAvailabilityExceptionRequest,
  ambassadorWixRestaurantsV1AvailabilityExceptionUniversalTypes.UpdateAvailabilityExceptionResponse,
  ambassadorWixRestaurantsV1AvailabilityExceptionTypes.UpdateAvailabilityExceptionResponse
> {
  const payload = {
    availabilityException: { id: ':availabilityExceptionId' },
  } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsV1AvailabilityException.updateAvailabilityException(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/availability-exceptions/{availabilityException.id}',
    pathParams: { availabilityExceptionId: 'availabilityExceptionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteAvailabilityException(): __PublicMethodMetaInfo<
  'DELETE',
  { availabilityExceptionId: string },
  ambassadorWixRestaurantsV1AvailabilityExceptionUniversalTypes.DeleteAvailabilityExceptionRequest,
  ambassadorWixRestaurantsV1AvailabilityExceptionTypes.DeleteAvailabilityExceptionRequest,
  ambassadorWixRestaurantsV1AvailabilityExceptionUniversalTypes.DeleteAvailabilityExceptionResponse,
  ambassadorWixRestaurantsV1AvailabilityExceptionTypes.DeleteAvailabilityExceptionResponse
> {
  const payload = {
    availabilityExceptionId: ':availabilityExceptionId',
  } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsV1AvailabilityException.deleteAvailabilityException(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/availability-exceptions/{availabilityExceptionId}',
    pathParams: { availabilityExceptionId: 'availabilityExceptionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryAvailabilityExceptions(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsV1AvailabilityExceptionUniversalTypes.QueryAvailabilityExceptionsRequest,
  ambassadorWixRestaurantsV1AvailabilityExceptionTypes.QueryAvailabilityExceptionsRequest,
  ambassadorWixRestaurantsV1AvailabilityExceptionUniversalTypes.QueryAvailabilityExceptionsResponse,
  ambassadorWixRestaurantsV1AvailabilityExceptionTypes.QueryAvailabilityExceptionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsV1AvailabilityException.queryAvailabilityExceptions(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/availability-exceptions/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateAvailabilityExceptions(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsV1AvailabilityExceptionUniversalTypes.BulkCreateAvailabilityExceptionsRequest,
  ambassadorWixRestaurantsV1AvailabilityExceptionTypes.BulkCreateAvailabilityExceptionsRequest,
  ambassadorWixRestaurantsV1AvailabilityExceptionUniversalTypes.BulkCreateAvailabilityExceptionsResponse,
  ambassadorWixRestaurantsV1AvailabilityExceptionTypes.BulkCreateAvailabilityExceptionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsV1AvailabilityException.bulkCreateAvailabilityExceptions(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/availability-exceptions/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateAvailabilityExceptions(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsV1AvailabilityExceptionUniversalTypes.BulkUpdateAvailabilityExceptionsRequest,
  ambassadorWixRestaurantsV1AvailabilityExceptionTypes.BulkUpdateAvailabilityExceptionsRequest,
  ambassadorWixRestaurantsV1AvailabilityExceptionUniversalTypes.BulkUpdateAvailabilityExceptionsResponse,
  ambassadorWixRestaurantsV1AvailabilityExceptionTypes.BulkUpdateAvailabilityExceptionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsV1AvailabilityException.bulkUpdateAvailabilityExceptions(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/availability-exceptions/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateAvailabilityExceptionTags(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsV1AvailabilityExceptionUniversalTypes.BulkUpdateAvailabilityExceptionTagsRequest,
  ambassadorWixRestaurantsV1AvailabilityExceptionTypes.BulkUpdateAvailabilityExceptionTagsRequest,
  ambassadorWixRestaurantsV1AvailabilityExceptionUniversalTypes.BulkUpdateAvailabilityExceptionTagsResponse,
  ambassadorWixRestaurantsV1AvailabilityExceptionTypes.BulkUpdateAvailabilityExceptionTagsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsV1AvailabilityException.bulkUpdateAvailabilityExceptionTags(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/availability-exceptions/update-tags',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateAvailabilityExceptionTagsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsV1AvailabilityExceptionUniversalTypes.BulkUpdateAvailabilityExceptionTagsByFilterRequest,
  ambassadorWixRestaurantsV1AvailabilityExceptionTypes.BulkUpdateAvailabilityExceptionTagsByFilterRequest,
  ambassadorWixRestaurantsV1AvailabilityExceptionUniversalTypes.BulkUpdateAvailabilityExceptionTagsByFilterResponse,
  ambassadorWixRestaurantsV1AvailabilityExceptionTypes.BulkUpdateAvailabilityExceptionTagsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsV1AvailabilityException.bulkUpdateAvailabilityExceptionTagsByFilter(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/availability-exceptions/update-tags-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  AvailabilityException as AvailabilityExceptionOriginal,
  AffectedFulfillmentMethods as AffectedFulfillmentMethodsOriginal,
  AffectedFulfillmentMethodsAffectedMethodsOptionsOneOf as AffectedFulfillmentMethodsAffectedMethodsOptionsOneOfOriginal,
  AffectedMethods as AffectedMethodsOriginal,
  AffectedMethodsWithLiterals as AffectedMethodsWithLiteralsOriginal,
  SpecificFulfillmentMethodsImpactScope as SpecificFulfillmentMethodsImpactScopeOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  Tags as TagsOriginal,
  TagList as TagListOriginal,
  CreateAvailabilityExceptionRequest as CreateAvailabilityExceptionRequestOriginal,
  CreateAvailabilityExceptionResponse as CreateAvailabilityExceptionResponseOriginal,
  GetAvailabilityExceptionRequest as GetAvailabilityExceptionRequestOriginal,
  GetAvailabilityExceptionResponse as GetAvailabilityExceptionResponseOriginal,
  UpdateAvailabilityExceptionRequest as UpdateAvailabilityExceptionRequestOriginal,
  UpdateAvailabilityExceptionResponse as UpdateAvailabilityExceptionResponseOriginal,
  DeleteAvailabilityExceptionRequest as DeleteAvailabilityExceptionRequestOriginal,
  DeleteAvailabilityExceptionResponse as DeleteAvailabilityExceptionResponseOriginal,
  QueryAvailabilityExceptionsRequest as QueryAvailabilityExceptionsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryAvailabilityExceptionsResponse as QueryAvailabilityExceptionsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  BulkCreateAvailabilityExceptionsRequest as BulkCreateAvailabilityExceptionsRequestOriginal,
  BulkCreateAvailabilityExceptionsResponse as BulkCreateAvailabilityExceptionsResponseOriginal,
  BulkCreateAvailabilityExceptionsResult as BulkCreateAvailabilityExceptionsResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkUpdateAvailabilityExceptionsRequest as BulkUpdateAvailabilityExceptionsRequestOriginal,
  MaskedAvailabilityException as MaskedAvailabilityExceptionOriginal,
  BulkUpdateAvailabilityExceptionsResponse as BulkUpdateAvailabilityExceptionsResponseOriginal,
  BulkAvailabilityExceptionResult as BulkAvailabilityExceptionResultOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  BulkUpdateAvailabilityExceptionTagsRequest as BulkUpdateAvailabilityExceptionTagsRequestOriginal,
  BulkUpdateAvailabilityExceptionTagsResponse as BulkUpdateAvailabilityExceptionTagsResponseOriginal,
  BulkUpdateAvailabilityExceptionTagsResult as BulkUpdateAvailabilityExceptionTagsResultOriginal,
  BulkUpdateAvailabilityExceptionTagsByFilterRequest as BulkUpdateAvailabilityExceptionTagsByFilterRequestOriginal,
  BulkUpdateAvailabilityExceptionTagsByFilterResponse as BulkUpdateAvailabilityExceptionTagsByFilterResponseOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  BulkUpdateAvailabilityExceptionTagsApplicationErrors as BulkUpdateAvailabilityExceptionTagsApplicationErrorsOriginal,
  BulkUpdateAvailabilityExceptionTagsByFilterApplicationErrors as BulkUpdateAvailabilityExceptionTagsByFilterApplicationErrorsOriginal,
} from './restaurants-v1-availability-exception-availability-exceptions.types.js';
